
































































import { Component } from "vue-property-decorator";
import { Tag, Swipe, SwipeItem, Icon } from "vant";
import AutoScroll from "@/components/AutoScroll.vue";
import { WithInject } from "../Mixins";
import CommentPop from "./CommentPop.vue";
import req from "@/api/portrait";
import { IHosts, ILiveInfo, IReplyItem } from "@/api/types";
import { Deprecated } from "@/common/decorator";

@Component({
  components: {
    Tag,
    Swipe,
    SwipeItem,
    Icon,
    AutoScroll,
    CommentPop
  }
})
export default class Comment extends WithInject {
  // 直播与聊天
  showWin = false;
  // 当前选择的主持人筛选队列
  hostIds: string[] = [];

  // 直播间主持人列表
  hostList: IHosts["data"] = [];

  // 用户评论弹幕
  get userComments(): IReplyItem[] {
    return this.liveInfo.replyList || [];
  }

  // 主持人轮播信息
  get hostComments(): ILiveInfo["classifyList"] {
    return this.liveInfo.classifyList || [];
  }

  isHost(user: IReplyItem) {
    const result = this.hostList.find(h => h.id + "" == user.userId);
    return result ? "主持人" : user.name;
  }

  // 获取主持人列表，这个接口暂时只用于匹配主持人发表评论后区分主持人弹幕的样式
  getHosts() {
    req.getHosts(this.$route.query.id as string).then(res => {
      if (res.code === 0) {
        this.hostList = res.data || [];
      }
    });
  }

  mounted() {
    this.getHosts();
    // if (this.$route.query.hostIds) {
    //   this.hostIds = (this.$route.query.hostIds as string).split("-");
    // } else {
    //   this.hostIds = [];
    // }
  }

  // 测试用 添加评论 暂时选择在Watch中对队列进行处理
  // 目前做的分享页 发不了评论
  @Deprecated
  addComment(comment: IReplyItem) {
    const rootEl = (this.$refs["auto-scroll"] as Vue).$el as HTMLElement;
    this.userComments.push(comment);
    // 添加评论后列表滚动到底部
    rootEl.scrollTop = rootEl.scrollHeight;
  }

  // 点击了评论区
  onCommentClick() {
    if (this.userComments.length || this.hostComments.length) {
      this.showWin = true;
    } else {
      this.$emit("trigger-play");
    }
  }
}
